import { Component, inject, input, signal, effect } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SupabaseService } from '@app/core/supabase.service';
import { ImageModule } from 'primeng/image';
import { SkeletonModule } from 'primeng/skeleton';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sb-image',
  imports: [
    ImageModule,
    SkeletonModule
  ],
  templateUrl: './sb-image.component.html',
  styleUrl: './sb-image.component.scss'
})
export class SbImageComponent {
  path = input<string>('');
  alt = input<string>('');
  imgClass = input<string>('');
  preview = input<boolean>(true);
  isPlaceholder = signal(true);
  
  domSanitizer = inject(DomSanitizer);
  supabase = inject(SupabaseService);
  loading = signal(true);
  imageUrl = signal<SafeResourceUrl | null>(null);
  placeholder = '/images/placeholder-image.png';

  constructor() {
    effect(() => {
      const p = this.path();
      if (p) {
        this.download(p);
      } else {
        this.isPlaceholder.set(true);
        this.imageUrl.set(this.placeholder);
        this.loading.set(false);
      }
    });
  }

  async download(path: string) {
    this.loading.set(true);
    const bucket = this.supabase.getStorageBucketName();
    try {
      const { data, error } = await this.supabase.client.storage.from(bucket).download(path);
      if (error) throw error;
      this.imageUrl.set(this.domSanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(data)));
      this.isPlaceholder.set(false);
    } catch (error) {
      console.error('Error downloading image', error);
      this.imageUrl.set(this.placeholder);
    } finally {
      this.loading.set(false);
    }
  }

  handleError() {
    this.imageUrl.set(this.placeholder);
    this.isPlaceholder.set(true);
  }

}
